// Carry Roll SmashFactor — smash factor display + valid-range flag (2.3).

import { AlertTriangle } from 'lucide-react';
import { useSmashFactor } from '../../store/selectors';

export function SmashFactor() {
  const { smash, valid } = useSmashFactor();
  if (smash == null) {
    return (
      <div className="text-sm" style={{ color: 'var(--color-text-muted)' }} data-testid="smash-factor">
        Smash factor: enter both speeds
      </div>
    );
  }
  return (
    <div
      className="text-sm"
      data-testid="smash-factor"
      style={{ color: valid ? 'var(--color-text)' : 'var(--color-danger)' }}
      role="status"
    >
      Smash factor: {smash.toFixed(2)}{' '}
      {!valid && (
        <>
          <AlertTriangle size={12} aria-hidden="true" style={{ verticalAlign: 'middle' }} /> outside 1.00–1.55
        </>
      )}
    </div>
  );
}
